import styled from "@emotion/styled";

export const SignInPasswordIcon = styled.img(() => ({
  cursor: "pointer",
}));
